module.exports = __webpack_public_path__ + "img/sharp.a4c26c2c.svg";